/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Shield16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M8 0l6.5 3.25v3.809c0 3.526-3.078 7.722-6.387 8.487L8 15.572l-.113-.026C4.578 14.781 1.5 10.585 1.5 7.06V3.25L8 0zm0 1.118l-5.5 2.75v3.191c0 3.035 2.7 6.757 5.5 7.485 2.8-.728 5.5-4.45 5.5-7.485V3.868L8 1.118zm3 3.441a.5.5 0 01.5.5v4a.5.5 0 11-1 0v-4a.5.5 0 01.5-.5z"
        />
    </AccessibleSVG>
);

export default Shield16;
